import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';

import { AppModule } from './app/app.module';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

void (async () => { // eslint-disable-line no-void
  try {
    await bootstrapApplication(AppComponent, {
      providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(AppModule),
      ],
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
})();
